import classNames from 'classnames';
import { get } from 'lodash';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ErrorItem, ErrorsPresenterContext, ErrorsPresenterContextProps } from '../ErrorsPresenter/ErrorsPresenter';

import './ControlErrorsView.css';

export interface ControlErrorsViewProps {
    cls?: string;
    path: string;
}

interface ControlErrorsViewComponentProps extends ControlErrorsViewProps {
    errors: ErrorItem[];
    onErrorsViewMount: (path: string) => void;
    onErrorsViewUnmount: (path: string) => void;
}

class ControlErrorsViewComponent extends React.PureComponent<ControlErrorsViewComponentProps> {
    componentWillMount() {
        const { onErrorsViewMount, path } = this.props;

        onErrorsViewMount(path);
    }

    componentWillUnmount() {
        const { onErrorsViewUnmount, path } = this.props;

        onErrorsViewUnmount(path);
    }

    render() {
        const { errors, cls } = this.props;

        if (!errors.length) {
            return null;
        }

        return (
            <div className={classNames(Bem.cls('control-errors-view'), cls)}>
                {errors.map(({ text, path }) => (
                    <div key={path} className={Bem.cls('control-errors-view', 'item')}>
                        {text}
                    </div>
                ))}
            </div>
        );
    }
}

export const ControlErrorsView = (props: ControlErrorsViewProps) => {
    return (
        <ErrorsPresenterContext.Consumer>
            {({ errors, onErrorsViewMount, onErrorsViewUnmount }: ErrorsPresenterContextProps) => (
                <ControlErrorsViewComponent
                    {...props}
                    errors={get(errors, props.path, [])}
                    onErrorsViewMount={onErrorsViewMount}
                    onErrorsViewUnmount={onErrorsViewUnmount}
                />
            )}
        </ErrorsPresenterContext.Consumer>
    );
};
